var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Appendix',{attrs:{"title":"Phụ lục QR quốc tế","actions":_vm.actions,"excepts":_vm.excepts,"only":_vm.only,"items":_vm.items,"contract":_vm.contract,"_showDetails":false},scopedSlots:_vm._u([{key:"file",fn:function(item){return [_c('AppendixQRFile',{attrs:{"item":item,"contract":_vm.contract}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }